import { gql } from '@apollo/client';

export const COMPARISONS_BLOCK = gql`
  fragment ComparisonsBlockFragment on Comparisons {
    showLeftContent
    leftContent
    secondaryComparison
    primaryComparison
    id
    blockName
    blockType
  }
`;
